import { useEffect } from "react";
import { useAuth } from "@/utils/auth";
import { Navigate } from "react-router-dom";
import { isAdminEmail } from "@/utils/admin";

export const ProtectedRoute = ({ children, requireAdmin = false }) => {
  const { isAuthenticated, isLoading, loginWithRedirect, user } = useAuth0();
  const isAdmin = isAdminEmail(user?.email);

  useEffect(() => {
    if (!isLoading && !isAuthenticated) {
      loginWithRedirect();
    }
  }, [isLoading, isAuthenticated, loginWithRedirect]);

  if (isLoading) {
    return (
      <div className="p-6 text-sm text-muted-foreground" data-testid="auth-loading">
        Loading...
      </div>
    );
  }

  if (!isAuthenticated) {
    return (
      <div className="p-6 text-sm text-muted-foreground" data-testid="auth-redirecting">
        Redirecting to login...
      </div>
    );
  }

  if (requireAdmin && !isAdmin) {
    return <Navigate to="/" replace />;
  }

  return children;
};
